import styles from "./NotificationButtonMessage.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

const createMessage = ({ text }) => {
  return (
    <p
      data-testid="notification-button-message"
      className={styles.notificationButtonMessage}
    >
      {text}
    </p>
  );
};

const NotificationButtonMessage = () => {
  const { getTranslation } = useRuntimeConstants();
  return createMessage({
    text: getTranslation("pdp_early_back_in_stock_messaging"),
  });
};

export default NotificationButtonMessage;
